import { render, staticRenderFns } from "./WithdrawPending.vue?vue&type=template&id=6f391fdc"
import script from "./WithdrawPending.vue?vue&type=script&lang=js"
export * from "./WithdrawPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports